"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../types/tape-builder-base");
const v4_1 = require("zod/v4");
exports.artifactType = 'fundingRequest';
// Zod schema and new config type
exports.NodeConfigSchema = v4_1.z
    .object({
    tapeDescription: v4_1.z
        .string()
        .describe('Description for funding request tape'),
    lenderVerificationConfig: tape_builder_base_1.LenderVerificationConfigSchema.optional().describe('Optional lender verification config'),
    fundingSubmissionComponentsArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Optional slug for funding submission components artifact'),
})
    .describe('DB node configuration');
// Zod schema and new node type
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: v4_1.z.null(),
    type: v4_1.z.literal(exports.artifactType),
    creditFacilitySlug: v4_1.z.string(),
    loanProductSlug: v4_1.z.null(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map